import axios from 'axios';
import AuthHandler from '../../Classes/AuthHandler';
import { GET_AUDIT_TRAILS_FOR_PO_AND_USER, GET_AUDIT_TRAILS_FOR_PO_AND_USER_ERROR,
    INSERT_AUDIT_TRAIL,INSERT_AUDIT_TRAIL_ERROR ,
    GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID,GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID_ERROR} from '../type';
import env from '../../ENV';
let ROOT_URL = env.BACKEND_URL;
AuthHandler.getUserPayLoad();

export const getAuditTrails = (id) => async dispatch => {
    try{
        const res = await axios.post(`${ROOT_URL}auditTrail/getAuditTrailsByRolePOAndPOLineItemId`,
        {
            PurchaseOrderId: 0,
            PurchaseOrderLineId: 8,
            ActionTypeID: 0,
            UserId : 0,
            RoleId : 0
        })
        dispatch({
            type: GET_AUDIT_TRAILS_FOR_PO_AND_USER,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_AUDIT_TRAILS_FOR_PO_AND_USER_ERROR,
            payload: console.log(e),
        })
    }
}

export const InsertAuditTrail = (data) => async dispatch => {
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}auditTrail/insertAuditTrail`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }                  
        })
        dispatch( {
            type: INSERT_AUDIT_TRAIL,
            payload: res.data
        })
    }
    catch(e){
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch( {
            type: INSERT_AUDIT_TRAIL_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetAuditTrailsByRolePOAndPOLineItemId = (data) => async dispatch => {
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/auditTrail/getAuditTrailsByRolePOAndPOLineItemId`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }                  
        })
        dispatch( {
            type: GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type:GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID_ERROR,
            payload: console.log(e),
        })
    }
}